<template>
    <div class="video-player">
		<vue-plyr v-if="youtubeId">
			<iframe
			:src="`https://www.youtube.com/embed/${youtubeId}?amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`"
				allowfullscreen
				allowtransparency
				allow="autoplay"
				frameborder="0"
				class="w-100 rounded"
				height="350"
			></iframe>
		</vue-plyr>
		
		<vue-plyr v-else :options="options">
				<video
				:debug="true"
				controls
				:src="video.url_stream_video || video.url"
			>
			</video>
		</vue-plyr>
    </div>
</template>

<script>
export default {
    props: {
		iframe: {
			type: Boolean,
			default: false
		},
		video: {
			type: Object,
			required: true
		},
		options: {
			type: Object
		},
		youtubeId: {
			default: null
		}
    },
}
</script>

<style lang="scss">
	.video-player {
		border-radius: 8px !important;
		overflow: hidden;
		.plyr--full-ui.plyr--video .plyr__control--overlaid {
			background: var(--v-accent-base);
			opacity: 1;
			&:hover {
				background: var(--v-accent-lighten1) !important;
				color: var(--v-accent-base);
			}
		}
		.plyr__volume input[type=range] {
			color: var(--v-accent-base);
		}
		.plyr__control:hover {
			background: var(--v-accent-base) !important;
		}
		.plyr--full-ui input[type=range] {
			color: var(--v-accent-base) !important;
		}
	}
</style>